import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Wendang"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.5 2.00016C2.5 1.35583 3.02233 0.833496 3.66667 0.833496H13C13.6443 0.833496 14.1667 1.35584 14.1667 2.00016V14.0002C14.1667 14.6445 13.6443 15.1668 13 15.1668H3.66667C3.02234 15.1668 2.5 14.6445 2.5 14.0002V2.00016ZM10.8332 9.50003H5.1665V10.5H10.8332V9.50003ZM5.1665 11.5H8.49984V12.5H5.1665V11.5ZM5.8665 3.50003C5.47991 3.50003 5.1665 3.81343 5.1665 4.20003V7.13336C5.1665 7.51996 5.4799 7.83336 5.8665 7.83336H10.1332C10.5198 7.83336 10.8332 7.51996 10.8332 7.13336V4.20003C10.8332 3.81343 10.5198 3.50003 10.1332 3.50003H5.8665ZM6.1665 6.83336V4.50003H9.83317V6.83336H6.1665Z",
  fill: "#737E99"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var wendang = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { wendang as default };
